import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 根据id，更新最近聊天信息
export function webUpdateRecentlyById(param,callback){
	request({
			method: 'post',
			url: 'recently/update',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，删除最近聊天记录
export function webDelRecentlyById(id,callback){
	request({
			method: 'post',
			url: 'recently/delRecentlyById',
			data: {
				id: id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}